import { Pin, X, ArrowLeft } from "lucide-react";
import { useDrafts } from "../../contexts/DraftsContext";

/**
 * Sticky chip strip showing all tabs with unsaved/in-progress drafts.
 * Clicking a chip switches to that tab. The 'x' on a chip discards the draft.
 */
const PendingDraftsBar = ({ activeTab, switchTab }) => {
  const { drafts, clearDirty } = useDrafts();
  const entries = Object.entries(drafts).filter(([id]) => id !== activeTab);
  if (entries.length === 0) return null;
  return (
    <div
      data-testid="pending-drafts-bar"
      className="sticky top-[64px] z-30 bg-[#FFFBEB] border-y-2 border-[#F59E0B] px-3 py-1.5 flex items-center gap-2 overflow-x-auto"
      dir="rtl"
    >
      <span className="text-xs font-bold text-[#9A3412] flex items-center gap-1 shrink-0">
        <Pin className="w-3.5 h-3.5" /> شُغل معلّق:
      </span>
      {entries.map(([tabId, d]) => (
        <div
          key={tabId}
          data-testid={`draft-chip-${tabId}`}
          className="flex items-center gap-1 bg-white border-2 border-[#F59E0B] rounded-full text-[11px] font-bold text-[#9A3412] pl-1 pr-2 py-0.5 shrink-0"
        >
          <button
            type="button"
            onClick={() => switchTab(tabId)}
            data-testid={`draft-chip-open-${tabId}`}
            className="flex items-center gap-1 hover:text-[#7C2D12]"
            title="استئناف"
          >
            <ArrowLeft className="w-3 h-3" />
            <span className="max-w-[140px] truncate">{d.label}</span>
          </button>
          <button
            type="button"
            onClick={() => clearDirty(tabId)}
            data-testid={`draft-chip-clear-${tabId}`}
            className="bg-[#FEE2E2] hover:bg-[#FECACA] text-[#E85D45] rounded-full p-0.5 mr-1"
            title="إلغاء المسودة"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default PendingDraftsBar;
